import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { LanguageChangeAction } from '../../common/actions/language.action';
import { Country } from '../../common/models/country.model';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import TokenRedirectService from '../../common/services/token-redirect.service';
import { UserResponse } from '../../common/services/user/user.model';
import UserService from '../../common/services/user/user.service';
import SecuredStorage from '../../common/services/local-storage/secured-storage.service';
import HttpService from '../../common/services/http.service';

/* @ngInject */
export default class FooterController {
  public countries: Country[] = [];
  public availableLanguages = [];
  public country: Country;
  public language: string;
  public user: UserResponse;
  public isShowMobileMenu = false;
  private redirectUrl: string;

  constructor(
    private $window,
    private config,
    private i18n,
    private userService: UserService,
    private httpService: HttpService,
    private actionDispatcher: ActionDispatcherService,
    private tokenRedirectService: TokenRedirectService,
    private securedStorage: SecuredStorage,
    private googleAnalytics: GoogleAnalyticsService
  ) {}

  public $onInit() {
    this.countries = this.config.countries;
    this.country = this.countries[0];
    this.availableLanguages = this.i18n.getAvailableLanguages();
    this.language = this.i18n.getCurrentLanguage();
    this.userService.getUserInfo().then(data => {
      this.user = data;
    });
  }
  public openAppStore() {
    this.$window.open(
      this.config.appstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openGooglePlay() {
    this.$window.open(
      this.config.playstore[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openWebPlayer() {
    this.tokenRedirectService.openPlayer();
  }

  public onLanguageChange = (lang: string) => {
    this.language = lang;
    this.i18n.useLanguage(this.language);
    this.actionDispatcher.dispatch(new LanguageChangeAction(this.language, true));
    this.googleAnalytics.writeVirtualPages({
      language: this.language
    });
    this.httpService.evictResultCache('getContract', true);
  };
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.controller.ts